import { useEffect, useState } from 'react';
import * as S from './style'
import { useLocation } from 'react-router-dom';
//hooks
import useLoading from "../../hooks/useLoading";
import apiRequest from '../../hooks/apiRequest';
//Components
import Loading from '../../components/Loading';
//interface
import { ILens } from 'Interfaces/ILens';
//Icons
import {
    ArrowBendUpLeft,
} from '@phosphor-icons/react';

export default function StockLensLab() {
    const location = useLocation();
    const selectedUrlId = location.state?.id; // Pegando o ID do estado

    const [data, setData] = useState<ILens | null>(null);
    const { isLoading, startLoading, stopLoading } = useLoading();

    const fetchData = async () => {
        startLoading();
        try {
            const response = await apiRequest<ILens>(`api-stock-lens/${selectedUrlId}`);
            const dataResponse = response.data;
            setData(dataResponse);
        } catch (error) {
            console.log("Error: ", error);
        } finally {
            stopLoading();
        }
    };

    useEffect(() => {
        if (selectedUrlId !== null) {
            fetchData();
        }
    }, [selectedUrlId]);

    if (isLoading || !data) {
        return <S.Container><Loading /></S.Container>;
    }

    const stock_visione = data.single_vision;
    const stock_multiple = data.multifocal_lens;

    // Pegar valores únicos de `spherical` e `cylindrical`;
    const uniqueSpherical = Array.from(new Set(stock_visione.map(item => item.spherical))).sort((a, b) => parseFloat(a) - parseFloat(b));
    const uniqueCylindrical = Array.from(new Set(stock_visione.map(item => item.cylindrical))).sort((a, b) => parseFloat(a) - parseFloat(b));

    // Pegar valores únicos de `spherical` e `addition (right, left)`;
    const uniqueSphericalMultiple = Array.from(new Set(stock_multiple.map(item => item.spherical))).sort((a, b) => parseFloat(a) - parseFloat(b));
    const uniqueAddition = Array.from(new Set(stock_multiple.map(item => item.addition))).sort((a, b) => parseFloat(a) - parseFloat(b));

    return (
        <S.Container>
            <S.Title>
                <S.Infor>
                    <S.H4>Registro de Lente</S.H4>
                    <S.H6>{data.name_lens}</S.H6>
                </S.Infor>
            </S.Title>

            <S.TableContainer>
                <S.TitleCylindrical>
                    {uniqueCylindrical.length > 0 ?
                        'Cilindro' :
                        'Adição'
                    }
                </S.TitleCylindrical>

                <S.ContentSph>
                    <S.TitleSpherical>Esférico</S.TitleSpherical>
                    <S.ScrollableContainer>
                        <S.Table>
                            <S.THead>
                                <S.TableRow>
                                    <S.CornerCell />
                                    {uniqueCylindrical.map(cyl => (
                                        <S.Th key={cyl}>{cyl}</S.Th>
                                    ))}
                                    {uniqueAddition.map(add => (
                                        <S.Th colSpan={2} key={add}>{add}</S.Th>
                                    ))}
                                </S.TableRow>
                                {
                                    uniqueAddition.length > 0 && (
                                        <S.TableRow>
                                            <S.CornerCell />
                                            {uniqueCylindrical.map(() => (
                                                <S.Th />
                                            ))}
                                            {uniqueAddition.flatMap(add => [
                                                <S.Th key={`${add}-L`}>L</S.Th>,
                                                <S.Th key={`${add}-R`}>R</S.Th>
                                            ])}
                                        </S.TableRow>
                                    )
                                }
                            </S.THead>

                            <S.TBody>
                                {uniqueSpherical && uniqueSpherical.map(sph => (
                                    <S.TableRowHover key={sph}>
                                        <S.FixedCell>{sph}</S.FixedCell>
                                        {uniqueCylindrical.map(cyl => {
                                            const lens = stock_visione.find(
                                                item => item.spherical === sph && item.cylindrical === cyl
                                            );
                                            return (
                                                <S.Td
                                                    key={`${sph}-${cyl}`}>
                                                    {
                                                        lens ? (
                                                            <>
                                                                {lens.quantity || 0}
                                                                {lens.cropped_lens > 0 &&
                                                                    <span> - {lens.cropped_lens}</span>
                                                                }
                                                            </>
                                                        ) : 0
                                                    }
                                                </S.Td>
                                            );
                                        })}
                                    </S.TableRowHover>
                                ))}
                                {/* Inicio Adição */}
                                {uniqueSphericalMultiple.map(sph => (
                                    <S.TableRowHover key={sph}>
                                        <S.FixedCell>{sph}</S.FixedCell>

                                        {uniqueAddition.map(add => {
                                            const lens = stock_multiple.find(
                                                item => item.spherical === sph && item.addition === add
                                            );

                                            return (
                                                <>
                                                    <S.Td>
                                                        {lens ? (
                                                            <>
                                                                {lens.left || 0}
                                                                {lens.cropped_lens_left > 0 &&
                                                                    <span> - {lens.cropped_lens_left}</span>
                                                                }
                                                            </>
                                                        ) : 0}
                                                    </S.Td>
                                                    <S.Td>
                                                        {lens ? (
                                                            <>
                                                                {lens.right || 0}
                                                                {lens.cropped_lens_right > 0 &&
                                                                    <span> - {lens.cropped_lens_right}</span>
                                                                }
                                                            </>
                                                        ) : 0}
                                                    </S.Td>
                                                </>
                                            );
                                        })}
                                    </S.TableRowHover>
                                ))}
                                {/* Fim Adição */}
                            </S.TBody>
                        </S.Table>
                    </S.ScrollableContainer>
                </S.ContentSph>

            </S.TableContainer>

            <S.Footer>
                <S.StyledNavLink
                    to={'/estoque'}>
                    <ArrowBendUpLeft size={24} />
                    Voltar para página de estoque
                </S.StyledNavLink>
            </S.Footer>
        </S.Container >
    )
}